<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <div>
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex md6>
                          <v-text-field
                            v-model="filters.tranType"
                            :label="labels.tranType"
                            :error-messages="errors.collect('tranType')"
                            data-vv-name="tranType"
                            :data-vv-as="labels.tranType"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md6>
                          <v-text-field
                            v-model="filters.polType"
                            :label="labels.polType"
                            :error-messages="errors.collect('polType')"
                            data-vv-name="polType"
                            :data-vv-as="labels.polType"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-1"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-layout row wrap>
            <v-spacer></v-spacer>
            <div>
              <v-btn color="primary" @click.native="doNew()">
                New Bonus Points
                <v-icon right>mdi-plus</v-icon>
              </v-btn>
            </div>
          </v-layout>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="items"
              v-bind:options.sync="pagination"
              :server-items-length="totalItems"
              :loading="loading"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row"
                ><tr>
                  <td>{{ row.item.tranType }}</td>
                  <td>{{ row.item.polType }}</td>
                  <td>{{ row.item.noRenewal }}</td>
                  <td>{{ row.item.premThreshVar }}</td>
                  <td>{{ formatDisplayDate(row.item.effDate) }}</td>
                  <td class="table-action-header">
                    <table-action
                      :rowData="row"
                      review
                      @review="doReview(row.item)"
                      remove
                      @remove="doPromptRemove(row.item)"
                      query
                      @query="doQuery(row.item)"
                    ></table-action>
                  </td></tr
              ></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove"> Are you sure that you want to delete the selected Bonus Points? </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import clone from 'clone'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      sideFunction: [
        {
          text: 'Sector',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'sector' }
        },
        {
          text: 'Division',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'division' }
        },
        {
          text: 'Team',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'team' }
        },
        {
          text: 'ARM',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'arm' }
        }
      ],
      toggleArray: [false],
      headers: [
        { text: 'Transaction Type', value: 'tranType' },
        { text: 'Policy Type', value: 'polType' },
        { text: 'No. of Renewals', value: 'noRenewal' },
        { text: 'Premium Threshold/Variable', value: 'premThreshVar' },
        { text: 'Effective Date', value: 'effDate' },
        TableConst.tableActionHeader
      ],
      labels: {
        tranType: 'Transaction Type',
        polType: 'Policy Type',
        noRenewal: 'No. of Renewals',
        premThreshVar: 'Premium Threshold/Variable',
        effDate: 'Effective Date'
      },
      filters: {
        tranType: undefined,
        polType: undefined
      },
      totalItems: 0,
      selectedProp: undefined,
      deleteProp: undefined,
      loading: false,
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  async mounted() {
    await this.$store.dispatch('boIncenSchemeInit')
    this.fetchData(true)
    this.doInit()
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async doInit() {
      this.fetchData(true)
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getSchemeBonusPtsList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let currFilters = clone(this.filters)
          if (currFilters.effDate) {
            currFilters.effDate = formatDisplayDateTime2(removeTime(currFilters.effDate))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), currFilters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  tranType: datamap.tranType,
                  polType: datamap.polType,
                  noRenewal: datamap.noRenewal,
                  premThreshVar: datamap.premThreshVar,
                  effDate: datamap.effDate
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.tranType = undefined
      this.filters.polType = undefined
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doReview(obj) {
      this.$router.push({ name: 'bonusPtsReview', params: { paramMode: 'review', paramObjRes: obj } })
    },
    doNew() {
      this.$router.push({ name: 'bonusPtsReview', params: { paramMode: 'create' } })
    },
    doQuery(obj) {
      this.$router.push({ name: 'bonusPtsReview', params: { paramMode: 'query', paramObjRes: obj } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedProp = data
      }
    },
    async doRemove() {
      const apiURI = this.menu.deleteSchemeBonusPts
      if (apiURI) {
        const expand = this.selectedProp
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    }
  },
  computed: {
    menu() {
      return this.$store.state.boIncenSchParam.boIncenScheme.menu
    }
  },
  components: {
    SideFunctionMenu
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
